export default __webpack_public_path__ + "static/media/workshop.812500e9.jpg";